<template>
  <div id="absent">
    <template v-if="PlugJson.PlugBody.AbsentNum==0">
      <van-tag plain type="warning">未上报缺考信息</van-tag>
    </template>
    <template v-else>
      <h5 class="color-blue">
        <span class="mr-1">实考率</span>
        {{(((PlugJson.PlugBody.TakeNum/PlugJson.PlugBody.StudentNum).toFixed(4))*100).toFixed(2)}}
        <small>%</small>
      </h5>
      <p>
        考生
        <b>{{PlugJson.PlugBody.StudentNum}}</b>人,
        缺考
        <b>{{PlugJson.PlugBody.AbsentNum}}</b>人,
        实考
        <b>{{PlugJson.PlugBody.TakeNum}}</b>人,
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: "absent",
  props: {
    PlugJson: Object
  }
};
</script>

<style scoped>
</style>